<script setup lang="ts">
import type { ColorTrimmed } from "~/common/interfaces/color-trimmed";

defineProps({
	colors: {
		type: Array as PropType<ColorTrimmed[]>,
		default () {
			return [];
		}
	}
});

const { ids, switchQueryId } = useQueryValueIdMapping("colors");
</script>

<template>
	<ul class="pt-3 flex flex-wrap gap-3 max-w-[256px]">
		<li v-for="{id, name, hex} in colors" :key="id">
			<AppCheckboxColor
				:name="name"
				:hex="hex"
				:model-value="ids.includes(id)"
				@update:model-value="switchQueryId(id)"
			/>
		</li>
	</ul>
</template>
